export const googleClientId =
    ''
export const facebookAppId = ''

export const appleLoginCredential = {
    appleId: 'f',
    serviceId: '',
    privateKey: '',
    redirectURI: ``,
}
